export const rejectionReasons = [
  { id: 1, name: 'Re-Submission' },
  { id: 2, name: "Candidate doesn't fit into the profile" },
  { id: 3, name: 'Incomplete candidate details - (Re-Submission)' },
];

export const config = {
  title: 'Reject',
  okText: 'Reject',
  okButtonDanger: true,
  width: 480,
  successMessage: 'Submission rejected successfully',
  fields: [
    {
      name: 'rejectReason',
      label: 'Rejection Reasons',
      type: 'select',
      required: true,
      placeholder: 'Select rejection reasons',
      defaultOptions: rejectionReasons.map((reason) => ({ label: reason.name, value: reason.id })),
    },
    {
      name: 'rejectReasonComments',
      label: 'Comments',
      type: 'textarea',
      required: true,
      rows: 4,
    },
  ],
};
